import Splide, { LOOP } from '@splidejs/splide';

const EL = '.js-Carousel'
const EL_NODE = document.querySelector('.js-Carousel')

if (EL_NODE) {
  const COUNT = EL_NODE.getAttribute('data-count')

  const slider = new Splide( EL, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: true,
  } ).mount();

  slider.on( 'move', function (newIndex) {
    removeClassByPrefix(EL_NODE, 'is-slide-')
    EL_NODE.classList.add('is-slide-'+newIndex)

    if((COUNT - 1) == newIndex) {
      EL_NODE.classList.add('is-slide-penultimate')
    }
  } );
}


function removeClassByPrefix(node, prefix) {
	var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
	node.className = node.className.replace(regx, '');
	return node;
}
